module.exports = __webpack_public_path__ + "static/img/pos_qrcode2.ec8d82d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/pos_qrcode2.png
// module id = rnLI
// module chunks = 8